import update from "immutability-helper";

import {
  USERS_LIST_SUCCESS,
  REQUEST_USERS_LIST
} from "./users-listing/users-listing-actions";

import { ADD_USER_SUCCESS } from "./users-form/users-form-actions";

const initialState = {
  users: [],
  isFetching: false
};

function usersAndPermissionsReducer(state = initialState, action) {
  switch (action.type) {
    case REQUEST_USERS_LIST:
      return update(state, {
        isFetching: { $set: true },
        users: { $set: action.data }
      });

    case USERS_LIST_SUCCESS:
      return update(state, {
        isFetching: { $set: false },
        users: { $set: action.data }
      });

    case ADD_USER_SUCCESS: {
      return update(state, {
        isFetching: { $set: false },
        users: { $set: [action.data, ...state.users] }
      });
    }

    default:
      return state;
  }
}

export default usersAndPermissionsReducer;



// WEBPACK FOOTER //
// ./src/components/users-and-permissions/users-and-permissions-reducer.js